module.exports = __webpack_public_path__ + "static/media/section-approvals-disabled.c5605f45.svg";